import styled from 'styled-components';

const AdminToggleButton = styled.button.attrs({ type: 'button' })`
   background-color: transparent;
   border: 1px solid ${({ theme }) => theme.primaryBlueDark};
   border-radius: 4px;
   padding: 4px 6px;
   font-weight: 600;
   min-width: 38px;
   &:hover {
      color: ${({ theme }) => theme.primaryWhite};
      background-color: ${({ theme }) => theme.primaryBlueDark};
      cursor: pointer;
   }
`;

export default AdminToggleButton;
